import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import {
  Card,
  Spinner,
  Table,
  Button,
  Row,
  Col,
  Badge,
  Alert,
  Modal,
} from "react-bootstrap";

import api from "./Api";

export default function ViewQuestion() {
  const { id } = useParams();

  const location = useLocation();

  const isDemo =
    new URLSearchParams(location.search).get("demo") ===
    "true";

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);

  const [videoLoading, setVideoLoading] =
    useState(true);

  const [pptLoading, setPptLoading] =
    useState(true);

  const [videos, setVideos] = useState([]);

  const [ppts, setPpts] = useState([]);

  const [deleteLoading, setDeleteLoading] =
    useState(false);

  const [showVideoModal, setShowVideoModal] =
    useState(false);

  const [selectedVideo, setSelectedVideo] =
    useState(null);

  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(true);

  // ================= FETCH QUESTION =================
useEffect(() => {

  const fetchQuestion = async () => {

    try {

      setLoading(true);

      const endpoint =
        `/pustak-questionbank/view-question/${id}?isDemo=${isDemo ? 1 : 0}`;

      console.log("QUESTION ENDPOINT", endpoint);

      const res = await api.get(endpoint);

      console.log("QUESTION RESPONSE", res.data);

      if (
        res.data.status === "success" ||
        res.data.status === true
      ) {

        setData(res.data.data || res.data);

      } else {

        setData(null);
      }

    } catch (err) {

      console.log(err);

      setData(null);

    } finally {

      setLoading(false);
    }
  };

  fetchQuestion();

  fetchVideos();
  fetchPPTs();
  fetchNotes();

}, [id, isDemo]);

  // ================= FETCH VIDEOS =================
const fetchVideos = async () => {

  try {

    setVideoLoading(true);

    const res = await api.get(
      `/question-media/videos/${id}?isDemo=${isDemo ? 1 : 0}`
    );

    if (
      res.data.status === "success" ||
      res.data.status === true
    ) {

      setVideos(res.data.data || []);

    } else {

      setVideos([]);
    }

  } catch (err) {

    console.log(err);

    setVideos([]);

  } finally {

    setVideoLoading(false);
  }
};

  // ================= FETCH PPT =================
 const fetchPPTs = async () => {

  try {

    setPptLoading(true);

    const res = await api.get(
      `/question-media/ppts/${id}?isDemo=${isDemo ? 1 : 0}`
    );

    if (
      res.data.status === "success" ||
      res.data.status === true
    ) {

      setPpts(res.data.data || []);

    } else {

      setPpts([]);
    }

  } catch (err) {

    console.log(err);

    setPpts([]);

  } finally {

    setPptLoading(false);
  }
};

  // ================= FETCH NOTES =================
const fetchNotes = async () => {

  try {

    setNotesLoading(true);

    const res = await api.get(
      `/question-notes/notes/${id}?isDemo=${isDemo ? 1 : 0}`
    );

    if (
      res.data.status === "success" ||
      res.data.status === true
    ) {

      setNotes(res.data.data || []);

    } else {

      setNotes([]);
    }

  } catch (err) {

    console.log(err);

    setNotes([]);

  } finally {

    setNotesLoading(false);
  }
};

  // ================= DELETE VIDEO =================
  const deleteVideo = async (videoId) => {
    if (
      !window.confirm(
        "Are you sure you want to delete this video?"
      )
    )
      return;

    try {
      setDeleteLoading(true);

      const res = await api.delete(
        `/question-media/video/${videoId}`
      );

      if (res.data.status === "success") {
        fetchVideos();
      }
    } catch (err) {
      console.log(err);

      alert("Failed to delete video");
    } finally {
      setDeleteLoading(false);
    }
  };

  // ================= DELETE PPT =================
  const deletePPT = async (pptId) => {
    if (
      !window.confirm(
        "Are you sure you want to delete this PPT?"
      )
    )
      return;

    try {
      setDeleteLoading(true);

      const res = await api.delete(
        `/question-media/ppt/delete/${pptId}`
      );

      if (res.data.status === "success") {
        fetchPPTs();
      }
    } catch (err) {
      console.log(err);

      alert("Failed to delete PPT");
    } finally {
      setDeleteLoading(false);
    }
  };

  // ================= DELETE NOTE =================
const deleteNote = async (noteId) => {

  if (!window.confirm("Delete this note?")) return;

  try {

    setDeleteLoading(true);

    const res = await api.delete(
      `/question-notes/delete/${noteId}`
    );

    if (res.data.status === "success") {
      fetchNotes();
    }

  } catch (err) {

    console.log(err);

    alert("Failed to delete note");

  } finally {

    setDeleteLoading(false);
  }
};

  // ================= LOADING =================
  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!data) {
    return (
      <Alert variant="danger">
        Question data not found.
      </Alert>
    );
  }

  const type = data.questype || data.questionType;

  return (
    <div className="container-fluid py-4">
      {/* ================= HEADER ================= */}
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
            <div>
              <h3 className="fw-bold mb-2">
                📘 {data.bank_name || "Question Bank"}
              </h3>

              <div className="d-flex flex-wrap gap-2">
                <Badge bg="primary">
                  {type}
                </Badge>

                <Badge bg="secondary">
                  {data.seriesname || "Subject"}
                </Badge>

                <Badge bg="dark">
                  {data.bookname || "Chapter"}
                </Badge>
              </div>
            </div>

            <Link
              to="/dashboard/question-bank"
              className="btn btn-secondary"
            >
              ⬅ Back
            </Link>
          </div>

          {data.description && (
            <p className="mt-3 text-muted mb-0">
              {data.description}
            </p>
          )}
        </Card.Body>
      </Card>

      {/* ================= VIDEOS ================= */}
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="fw-bold mb-0">
              🎥 Videos
            </h4>

            <Badge bg="danger">
              {videos.length} Videos
            </Badge>
          </div>

          {videoLoading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : videos.length === 0 ? (
            <Alert variant="light">
              No videos uploaded yet.
            </Alert>
          ) : (
            <Row className="g-4">
              {videos.map((video) => (
                <Col
                  lg={4}
                  md={6}
                  key={video.id}
                >
                  <Card className="h-100 border-0 shadow rounded-4 overflow-hidden">
                    {/* VIDEO PREVIEW */}
                    {video.video_type ===
                      "upload" &&
                    video.video_file_url ? (
                      <video
                        src={
                          video.video_file_url
                        }
                        controls
                        className="w-100"
                        style={{
                          height: 220,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        className="bg-dark text-white d-flex align-items-center justify-content-center"
                        style={{ height: 220 }}
                      >
                        <div className="text-center p-3">
                          <h1>▶</h1>

                          <small>
                            Youtube / External
                            Video
                          </small>
                        </div>
                      </div>
                    )}

                    <Card.Body>
                      <h5 className="fw-bold">
                        {video.title ||
                          "Untitled Video"}
                      </h5>

                      <p className="text-muted small">
                        {video.description ||
                          "No description"}
                      </p>

                      <div className="d-flex gap-2 flex-wrap">
                        {/* VIEW */}
                        {video.video_type ===
                          "upload" &&
                        video.video_file_url ? (
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              setSelectedVideo(
                                video
                              );

                              setShowVideoModal(
                                true
                              );
                            }}
                          >
                            ▶ Watch
                          </Button>
                        ) : (
                          <Button
                            variant="primary"
                            size="sm"
                            href={
                              video.video_url
                            }
                            target="_blank"
                          >
                            🔗 Open
                          </Button>
                        )}

                        {/* DELETE */}
                        <Button
                          variant="danger"
                          size="sm"
                          disabled={
                            deleteLoading
                          }
                          onClick={() =>
                            deleteVideo(
                              video.id
                            )
                          }
                        >
                          🗑 Delete
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Card.Body>
      </Card>

      {/* ================= PPT ================= */}
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="fw-bold mb-0">
              📊 PPT / Documents
            </h4>

            <Badge bg="primary">
              {ppts.length} Files
            </Badge>
          </div>

          {pptLoading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : ppts.length === 0 ? (
            <Alert variant="light">
              No PPT uploaded yet.
            </Alert>
          ) : (
            <Row className="g-4">
              {ppts.map((ppt) => (
                <Col
                  lg={4}
                  md={6}
                  key={ppt.id}
                >
                  <Card className="h-100 border-0 shadow rounded-4">
                    <Card.Body>
                      <div className="text-center mb-3">
                        <div
                          style={{
                            fontSize: 70,
                          }}
                        >
                          📄
                        </div>
                      </div>

                      <h5 className="fw-bold text-center">
                        {ppt.title ||
                          "Untitled PPT"}
                      </h5>

                      <p className="text-muted small text-center">
                        {ppt.description ||
                          "No description"}
                      </p>

                      <div className="d-flex justify-content-center gap-2 flex-wrap mt-3">
                        {/* VIEW */}
                        {ppt.ppt_type ===
                          "upload" &&
                        ppt.ppt_file_url ? (
                          <Button
                            variant="primary"
                            size="sm"
                            href={
                              ppt.ppt_file_url
                            }
                            target="_blank"
                          >
                            📥 Download
                          </Button>
                        ) : (
                          <Button
                            variant="primary"
                            size="sm"
                            href={ppt.ppt_url}
                            target="_blank"
                          >
                            🔗 Open URL
                          </Button>
                        )}

                        {/* DELETE */}
                        <Button
                          variant="danger"
                          size="sm"
                          disabled={
                            deleteLoading
                          }
                          onClick={() =>
                            deletePPT(
                              ppt.id
                            )
                          }
                        >
                          🗑 Delete
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Card.Body>
      </Card>


      {/* ================= NOTES FILES ================= */}
<Card className="border-0 shadow-sm rounded-4 mb-4">
  <Card.Body>

    <div className="d-flex justify-content-between align-items-center mb-4">

      <h4 className="fw-bold mb-0">
        📝 Notes / PDFs
      </h4>

      <Badge bg="success">
        {notes.length} Notes
      </Badge>

    </div>

    {notesLoading ? (

      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>

    ) : notes.length === 0 ? (

      <Alert variant="light">
        No Notes uploaded yet.
      </Alert>

    ) : (

      <Row className="g-4">

        {notes.map((note) => (

          <Col lg={4} md={6} key={note.id}>

            <Card className="h-100 border-0 shadow rounded-4">

              <Card.Body>

                <div className="text-center mb-3">

                  <div
                    style={{
                      fontSize: 70,
                    }}
                  >
                    📝
                  </div>

                </div>

                <h5 className="fw-bold text-center">
                  {note.title || "Untitled Note"}
                </h5>

                <p className="text-muted small text-center">
                  {note.description || "No description"}
                </p>

                <div className="d-flex justify-content-center gap-2 flex-wrap mt-3">

                  {/* VIEW */}
                  {note.note_type === "upload" &&
                  note.note_file_url ? (

                    <Button
                      variant="success"
                      size="sm"
                      href={note.note_file_url}
                      target="_blank"
                    >
                      📥 Download
                    </Button>

                  ) : (

                    <Button
                      variant="success"
                      size="sm"
                      href={note.note_url}
                      target="_blank"
                    >
                      🔗 Open URL
                    </Button>

                  )}

                  {/* DELETE */}
                  <Button
                    variant="danger"
                    size="sm"
                    disabled={deleteLoading}
                    onClick={() =>
                      deleteNote(note.id)
                    }
                  >
                    🗑 Delete
                  </Button>

                </div>

              </Card.Body>

            </Card>

          </Col>

        ))}

      </Row>

    )}

  </Card.Body>
</Card>

      {/* ================= QUESTIONS ================= */}
      <Card className="border-0 shadow-sm rounded-4">
        <Card.Body>
          <h4 className="fw-bold mb-4">
            📚 Questions / Content
          </h4>

          {/* NOTES */}
          {type === "NOTES" &&
            data.quesJson?.map(
              (noteObj, idx) => (
                <Card
                  key={idx}
                  className="mb-3 border-0 shadow-sm rounded-4"
                >
                  <Card.Body>
                    <h5 className="fw-bold mb-3">
                      📝 Note {idx + 1}
                    </h5>

                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          noteObj.note
                            .replace(
                              /^### (.*$)/gim,
                              "<h3 style='color:#0d6efd'>$1</h3>"
                            )
                            .replace(
                              /^#### (.*$)/gim,
                              "<h4 style='color:#2563eb'>$1</h4>"
                            )
                            .replace(
                              /\*\*(.*?)\*\*/gim,
                              "<b>$1</b>"
                            )
                            .replace(
                              /\n/g,
                              "<br />"
                            ),
                      }}
                    />
                  </Card.Body>
                </Card>
              )
            )}

          {/* MCQ */}
          {type !== "NOTES" &&
            Array.isArray(data.quesJson) &&
            data.quesJson.map((q, i) => (
              <Card
                key={i}
                className="mb-3 border-0 shadow-sm rounded-4"
              >
                <Card.Body>
                  <h5 className="fw-bold">
                    Q{i + 1}. {q.question}
                  </h5>

                  {Array.isArray(q.options) && (
                    <ul className="mt-3">
                      {q.options.map(
                        (opt, idx) => (
                          <li key={idx}>
                            {opt}
                          </li>
                        )
                      )}
                    </ul>
                  )}

                  {q.correct_answer && (
                    <Alert
                      variant="success"
                      className="mt-3 mb-0"
                    >
                      <strong>
                        Answer:
                      </strong>{" "}
                      {
                        q.correct_answer
                      }
                    </Alert>
                  )}
                </Card.Body>
              </Card>
            ))}
        </Card.Body>
      </Card>

      {/* ================= VIDEO MODAL ================= */}
      <Modal
        show={showVideoModal}
        onHide={() =>
          setShowVideoModal(false)
        }
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            🎥{" "}
            {selectedVideo?.title ||
              "Video"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedVideo?.video_file_url && (
            <video
              src={
                selectedVideo.video_file_url
              }
              controls
              autoPlay
              className="w-100 rounded"
              style={{
                maxHeight: "75vh",
              }}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}